import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { DEVOPS_AND_CLOUD_PROGRAM } from "../../constants/AzureDevops";

export default function StatsSectionV3(props) {
  const {course} = props
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isDevopsAndCloudProgram = course === DEVOPS_AND_CLOUD_PROGRAM;

  const mobileStats = [
    { value: isDevopsAndCloudProgram ? "4 Months" : "6 Months", label: "Program Duration" },
    { value: "35", label: "Guaranteed Opportunities" },
    { value: isDevopsAndCloudProgram ? "Microsoft / AWS" : "Microsoft & AWS", label: "Certification" },
  ];

  const desktopStats = [
    { value: isDevopsAndCloudProgram ? "4 Months" : "6 Months", label: "Program Duration" },
    { value: "35", label: "Guaranteed Opportunities" },
    { value: isDevopsAndCloudProgram ? "150+ Hours" : "300+ Hours", label: "Instructor-Led Sessions" },
    { value: "25+ Years", label: "Experienced Industry Faculty" },
    { value: isDevopsAndCloudProgram ? "Microsoft / AWS" : "Microsoft & AWS", label: "Certification" },
  ];

  const stats = isMobile ? mobileStats : desktopStats;


  return (
    <Box
      sx={{
        backgroundColor: "#f4e9ff",
        py: { xs: 4, md: 3 },
        px: { xs: 2, md: "5%" },
      }}
    >
      <Box
        sx={{
          maxWidth: {xs:"100%", md:"85%"},
          mx: "auto",
          display: "grid",
          gridTemplateColumns: { xs: "repeat(3, 1fr)", md: "repeat(5, 1fr)" },
          gap: { xs: 2, md: 2 },
          alignItems: "center",
          textAlign: "center",
        }}
      >
        {stats.map((stat, idx) => (
          <Box
            key={idx}
            sx={{
              py: 2,
              px: { xs: 0, md: 1 },
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: stat.value.length > 10 ? "0.75rem" : "1rem",
                  md: "1.7rem",
                },
                fontWeight: 800,
                color: "#8C00FF",
                mb: { xs: 0.3, md: 0.5 },
                fontFamily: "Poppins, sans-serif",
                whiteSpace: "nowrap",
              }}
            >
              {stat.value}
            </Typography>
            <Typography
              sx={{
                fontSize: {
                  xs: "9px",
                  md: stat.label.length > 20 ? "11px" : "13px",
                },
                color: "#666",
                fontWeight: 500,
                fontFamily: "Poppins, sans-serif",
                lineHeight: 1.3,
                whiteSpace: { md: "nowrap" },
              }}
            >
              {stat.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
